/**
 * Liens espace apprenant : préfère l’origine du navigateur (`window.location.origin`)
 * pour éviter un port/host erroné renvoyé par l’API (ex. confusion APP_URL / backend).
 */

export function unwrapApiPayload<T>(raw: unknown): T {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    const d = (raw as { data: unknown }).data;
    if (d !== undefined) return d as T;
  }
  return raw as T;
}

/** Réécrit une URL absolue de l’API vers l’origine actuelle du SPA (même chemin + query). */
function samePathOnCurrentOrigin(absoluteUrl: string): string {
  if (typeof window === 'undefined') return absoluteUrl;
  try {
    const u = new URL(absoluteUrl);
    return `${window.location.origin}${u.pathname}${u.search}`;
  } catch {
    return absoluteUrl;
  }
}

export function buildFormationPlayUrl(
  flowId: string,
  opts: { token?: string | null; apiUrl?: string | null },
): string {
  const { token, apiUrl } = opts;
  const path = `/eduflow/flows/${flowId}/play`;
  const withToken = token ? `${path}?accessToken=${encodeURIComponent(token)}` : path;

  if (typeof window !== 'undefined') {
    if (token) return `${window.location.origin}${path}?accessToken=${encodeURIComponent(token)}`;
    if (apiUrl) return samePathOnCurrentOrigin(apiUrl);
    return `${window.location.origin}${path}`;
  }
  return withToken;
}

/**
 * Avec jeton : page plein écran `/podcasts/learner` (lecteur, onglet dédié).
 * Sans jeton : liste podcasts dans l’espace apprenant (navigation interne uniquement).
 */
export function buildLearnerPodcastUrl(
  podcastId: string,
  opts: { token?: string | null; apiUrl?: string | null },
): string {
  const { token, apiUrl } = opts;

  if (typeof window !== 'undefined') {
    if (token) {
      const qs = new URLSearchParams();
      qs.set('accessToken', token);
      qs.set('podcastId', podcastId);
      return `${window.location.origin}/podcasts/learner?${qs.toString()}`;
    }
    if (apiUrl) return samePathOnCurrentOrigin(apiUrl);
    return `${window.location.origin}/learner?tab=podcasts&podcastId=${encodeURIComponent(podcastId)}`;
  }

  if (token) {
    const qs = new URLSearchParams();
    qs.set('accessToken', token);
    qs.set('podcastId', podcastId);
    return `/podcasts/learner?${qs.toString()}`;
  }
  return `/learner?tab=podcasts&podcastId=${encodeURIComponent(podcastId)}`;
}
